// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jut__Accordion__accordion__PPEnhv{display:block}", "",{"version":3,"sources":["webpack://./../../platform/@jutro/components/components/Accordion/Accordion.module.css"],"names":[],"mappings":"AAAA,mCACE,aAAA","sourcesContent":[".accordion {\n  display: block;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"accordion": "jut__Accordion__accordion__PPEnhv"
};
export default ___CSS_LOADER_EXPORT___;
